export const summary = `\
I am a tech enthusiast with a 20+ years journey in the sector,
transitioning from Systems Engineer to CTO.
Self-taught and skilled in Linux, Python,
and cloud automation with tools like Saltstack, Puppet, Pulumi, and Terraform,
I excel in creating efficient, scalable solutions.
My expertise also covers IP networking, React, TypeScript,
and I am now learning hardware engineering.
Though versed in engineering management, I prioritize hands-on technical roles,
focusing on pragmatic, innovative problem-solving.
`;
